var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsUpSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#EBEDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16.5C31 18.433 29.433 20 27.5 20C25.567 20 24 18.433 24 16.5C24 14.567 25.567 13 27.5 13C29.433 13 31 14.567 31 16.5Z",
    stroke: "#384BFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5C13 14.8501 13 14.0251 13.5126 13.5126C14.0251 13 14.8501 13 16.5 13C18.1499 13 18.9749 13 19.4874 13.5126C20 14.0251 20 14.8501 20 16.5C20 18.1499 20 18.9749 19.4874 19.4874C18.9749 20 18.1499 20 16.5 20C14.8501 20 14.0251 20 13.5126 19.4874C13 18.9749 13 18.1499 13 16.5Z",
    stroke: "#384BFF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 27.5C13 25.8501 13 25.0251 13.5126 24.5126C14.0251 24 14.8501 24 16.5 24C18.1499 24 18.9749 24 19.4874 24.5126C20 25.0251 20 25.8501 20 27.5C20 29.1499 20 29.9749 19.4874 30.4874C18.9749 31 18.1499 31 16.5 31C14.8501 31 14.0251 31 13.5126 30.4874C13 29.9749 13 29.1499 13 27.5Z",
    stroke: "#384BFF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5C24 25.8501 24 25.0251 24.5126 24.5126C25.0251 24 25.8501 24 27.5 24C29.1499 24 29.9749 24 30.4874 24.5126C31 25.0251 31 25.8501 31 27.5C31 29.1499 31 29.9749 30.4874 30.4874C29.9749 31 29.1499 31 27.5 31C25.8501 31 25.0251 31 24.5126 30.4874C24 29.9749 24 29.1499 24 27.5Z",
    stroke: "#384BFF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20V24M24 27.5H20M20 16.5H24",
    stroke: "#384BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsUpSvg);
export default __webpack_public_path__ + "static/media/AnalyticsUpSvg.92e7e7b7dbc4804fba708d78357681e1.svg";
export { ForwardRef as ReactComponent };